import React from "react";

const TermsUse = () => {
  return (
    <div className="wrap_main">
      <div className="doc-contents">
        <h1>일반 이용 약관</h1>
        <h3 id="article1">1. 웹사이트 콘텐츠</h3>
        <p>
          <span className="head_sentence">
            1.1. 서비스의 성격 및 당사 콘텐츠.
          </span>{" "}
          본 웹사이트는 스포츠 경기 결과, 일정 및 기타 스포츠 통계와
          스포츠 콘텐츠("당사 콘텐츠")를 포함하여 스포츠 이벤트에 관한 최신 정보를 담고 있습니다.
          웹사이트에 표시되는 당사 콘텐츠는 다른 독립적인 소스(제3자)가 제공하거나 당사의 노력으로
          수집한 정보에 기초합니다. 당사는 웹사이트에 표시되는 당사 콘텐츠를 정기적으로 업데이트하고
          확인하기 위해 모든 노력을 기울이지만, 웹사이트에 대해 어떠한 약속이나 보증도 하지 않으며
          사용자가 웹사이트에서 수집된 정보를 원본 및 다른 소스와도 신중하게 비교해 볼 것을 권장합니다.
        </p>
        <p>
          <span className="head_sentence">
            1.2. 사이트 이용의 위험 부담.
          </span>{" "}
          당사는 본 약관에 기술된 방식에 따라 당사로부터 합리적으로 요구될
          수 있는 수준의 성실함과 주의를 기울여 웹사이트를 운영하고 콘텐츠를 제공합니다. 그러나
          사용자의 웹사이트 접속 및 이용, 그리고 웹사이트와 관련하여 사용자에게 제공될 수 있는 모든
          정보의 사용은 전적으로 사용자의 선택, 판단 및 위험 부담에 따르며, 개인적인 용도로만 사용해야
          합니다. 사용자는 웹사이트나 당사의 콘텐츠를 상업적인 목적으로 사용할 수 없습니다.
        </p>
        <p>
          <span className="head_sentence">1.3. 회원가입.</span> 웹사이트의 특정 부분이나 기능을 사용하기 위해 회원가입이 필요할 수 있습니다.
          회원가입을 하지 않을 경우 모든 콘텐츠를 열람하거나 이용할 수 없으며 웹사이트 기능이 제한될 수
          있습니다.
        </p>
        <p>
          <span className="head_sentence">1.4. 제3자 콘텐츠.</span> 당사는 웹사이트에서 접속할 수 있는 외부 애플리케이션이나 리소스를 위해
          콘텐츠를 제공하지 않습니다. 웹사이트에서 이용 가능한 모든 제3자 콘텐츠는 당사의 서버에
          호스팅되지 않으며, 당사가 이를 생성하거나 해당 서버에 업로드하지도 않습니다. 제3자 콘텐츠는
          일반적으로 해당 로고, 아이콘 또는 기타 제3자 식별자로 표시됩니다. 당사는 이러한 콘텐츠,
          콘텐츠의 가용성 또는 그에 포함된 정보와 관련된 어떠한 책임도 명시적으로 배제합니다.
        </p>
        <p>
          <span className="head_sentence">1.5. 광고 표시.</span> 별도의 합의가 없는 한, 사용자는 제3자 광고를 포함한 광고가 서비스에 표시될 수
          있음에 동의합니다.
        </p>
        <p>
          <span className="head_sentence">
            1.6. 쿠키 및 쿠키 동의 관리 도구.
          </span>{" "}
          당사는 제3자가 운영하는 특정 디지털 솔루션을 통해 쿠키에 관한
          세부 사항을 안내하고 사용자의 동의를 수집합니다.
        </p>
        <p>
          <span className="head_sentence">1.7. 도박과의 관계.</span>{" "}
          본 웹사이트는 게임 애플리케이션이나 도박 애플리케이션이 아닙니다. 당사는
          게임이나 도박을 운영하지 않으므로 사용자의 자금이나 기타 금전을 수락하거나 통제하지 않으며,
          어떠한 도박 관련 거래에도 참여하지 않습니다. 웹사이트에 표시된 배당률은 정보 보고 및 비교
          목적으로 제공됩니다. 웹사이트에 게시된 어떠한 통신이나 정보도 게임 참여나 베팅을 권유하는
          것이 아니며, 게임이나 도박과 관련된 법률, 세무 또는 기타 유사한 조언을 구성하지 않습니다.
        </p>
        <p>
          <span className="head_sentence">1.8. 현지 법률.</span> 사용자가 일시적 또는 영구적으로 거주하는 국가, 시민권을 보유한 국가 및/또는
          현재 머물고 있는 국가의 관련 법률을 준수할 것을 권장합니다.
        </p>
        <p>
          <span className="head_sentence">1.9. 콘텐츠 권리.</span> 웹사이트에 포함된 텍스트, 사진, 그래픽 저작물 및 기타 요소는 개별적으로
          그리고/또는 전체로서(이하 통칭하여 "저작물") 저작권의 보호를 받을 수 있습니다. 당사와 서면으로
          달리 합의하지 않는 한, 저작물의 공정 이용은 관련 법률이 정하는 범위와 방식 내에서만
          가능합니다. 특히 직접적 또는 간접적인 경제적 이익을 목적으로 하는 복제(카피) 형태의 저작물
          사용과 배포, 대여, 전시 또는 공중 송신(인터넷을 통한 공중 송신 포함) 형태의 사용은 당사의
          명시적인 동의 없이는 허용되지 않습니다.
        </p>
        <p>
          <span className="head_sentence">1.10. 데이터베이스 보호.</span>{" "}
          웹사이트에 포함된 콘텐츠 데이터베이스(이하 "데이터베이스 콘텐츠")는
          데이터베이스 제작자의 특별한 권리에 의해 보호됩니다. 당사와 서면으로 달리 합의하지 않는 한,
          데이터베이스 콘텐츠의 적법한 이용은 관련 법률이 정하는 범위와 방식 내에서만 가능합니다. 특히
          당사의 명시적인 동의 없이는 데이터베이스 콘텐츠 또는 그 질적·양적으로 상당한 부분에 대한 추출
          (복제)이나 이용(공중 제공)은 허용되지 않습니다.
        </p>
        <p>
          <span className="head_sentence">1.11. 불법적인 간섭.</span>{" "}
          사용자는 당사 시설의 운영, 인터넷 보안 또는 다른 인터넷 사용자에게
          부정적인 영향을 미치거나 미칠 수 있는 어떠한 메커니즘, 도구, 소프트웨어 또는 프로세스도 사용할
          수 없습니다. 사용자는 웹사이트가 호스팅되는 당사의 서버에 자동화된 요청으로 부하를 주어서는
          안 되며, 제3자의 그러한 활동을 도와서도 안 됩니다. 사용자는 관련 법령에서 달리 요구하지 않는
          한, 어떤 방식으로든 웹사이트를 수정, 분해, 역컴파일 또는 역설계할 수 없습니다. 또한 사용자는
          관련 법령에서 달리 규정하지 않는 한, 당사의 명시적인 동의 없이 임베딩, 집계, 스크래핑 또는
          재현하는 방식으로 웹사이트에서 이용 가능한 당사 콘텐츠를 사용하는 것이 금지됩니다.
        </p>
        <p>
          <span className="head_sentence">
            1.12. 권리 침해의 결과.
          </span>{" "}
          사용자의 저작권, 상표권 침해 또는 데이터베이스 제작자의 특별한 권리에
          대한 간섭은 민사, 행정 또는 형사상의 책임을 초래할 수 있습니다.
        </p>
        <h3 id="article2">
          2. 서비스 제공 계약의 체결
        </h3>
        <p>
          <span className="head_sentence">2.1. 회원가입.</span> 사용자는 웹사이트에 있는 등록 양식의 정보를 작성하고 "계정 생성" 버튼 또는 ("
          등록 신청")을 클릭함으로써 서비스 계약 체결을 제안하게 됩니다. 사용자는 등록 신청서에 제공된
          정보가 정확한지 확인할 책임이 있습니다.
        </p>
        <p>
          <span className="head_sentence">2.2. 활성화.</span> 등록 신청을 접수한 후, 당사는 사용자의 등록 신청을 수락하고 등록 요청 시 제공된
          사용자의 이메일 주소("사용자 주소")로 사용자 계정을 활성화하고 작동시키는 데 필요한 정보를
          보낼 수 있습니다. 사용자가 계정을 활성화하면 서비스 계약이 체결됩니다.
        </p>
        <p>
          <span className="head_sentence">
            2.3. 제3자 등록 사용.
          </span>{" "}
          사용자가 기존의 제3자 등록(예: 소셜 네트워크 등록)을 사용하는 경우, 해당
          제3자의 로고, 상표 및/또는 서비스명이 표시된 "로그인" 버튼을 클릭하고 해당 제3자를 통해 등록
          및 로그인을 확인함으로써 당사에 서비스 계약 체결 제안을 보낼 수 있습니다. 위 문장에 따른
          서비스 계약 체결 제안이 당사에 전달되면 사용자는 서비스를 이용할 수 있게 됩니다. 당사가
          사용자의 서비스 이용을 허용함으로써 서비스 계약이 체결됩니다.
        </p>
        <p>
          <span className="head_sentence">
            2.4. 서비스 제공에 대한 동의.
          </span>{" "}
          사용자는 법정 철회 기간이 경과하기 전이라도 서비스 계약 체결 즉시
          당사가 서비스 제공을 시작할 수 있음에 동의합니다.
        </p>
        <p>
          <span className="head_sentence">
            2.5. 통신 장비 비용.
          </span>{" "}
          사용자는 서비스 계약 체결 시 원격 통신 수단을 사용하는 것에 동의합니다.
          서비스 계약 체결과 관련하여 원격 통신 수단을 사용함에 있어 발생하는 비용(예: 인터넷 접속 비용)
          은 사용자가 별도로 부담하며, 이는 해당 통신 수단 이용을 위한 기본 요율과 다르지 않습니다.
        </p>

        <h3 id="article3">3. 서비스 계약의 내용</h3>
        <p>
          <span className="head_sentence">3.1. 계약의 목적.</span>{" "}
          서비스 계약에 기초하여 당사는 사용자가 당사 웹사이트에서 사용자 계정을
          생성하고 등록 및 계정 활성화가 필요한 콘텐츠와 기능(이하 "서비스")을 이용할 수 있도록 합니다.
        </p>
        <p>
          <span className="head_sentence">3.2. 계약의 내용.</span>{" "}
          본 이용 약관은 서비스 계약의 불가분한 일부를 구성합니다.
        </p>
        <p>
          <span className="head_sentence">3.3. 계약 언어.</span>{" "}
          본 서비스 제공 계약은 한국어로 체결됩니다.
          (다만, 7.1조에 명시된 바와 같이 개인정보 처리에 관해서는 글로벌 표준인 GDPR 및 관련 법령을
          준수합니다.)
        </p>

        <h3 id="article4">4. 사용자 계정</h3>
        <p>
          <span className="head_sentence">4.1. 계정 보호.</span> 사용자 계정 접속은 사용자 이름과 비밀번호 또는 제3자 로그인 도구로 보호됩니다.
          사용자는 자신의 사용자 계정 접속에 필요한 정보의 비밀을 유지해야 하며, 사용자가 이 의무를
          위반하여 발생하는 어떠한 책임도 당사가 지지 않음을 인정합니다.
        </p>
        <p>
          <span className="head_sentence"> 4.2. 사용자 계정 기능.</span>{" "}
          사용자 계정을 통해 사용자는 서비스를 온전하게 이용할 수 있습니다.
        </p>
        <p>
          <span className="head_sentence">
            4.3. 콘텐츠 개인화.
          </span>{" "}
          사용자는 자신의 필요에 따라 서비스 콘텐츠를 조정할 권리가 있으나, 이는 항상
          서비스에서 제공하는 설정 옵션 범위 내에서만 가능합니다.
        </p>

        <h3 id="article5">5. 당사의 유보 사항</h3>
        <p>
          <span className="head_sentence">
            5.1. 서비스 제공 불능.
          </span>{" "}
          사용자 측 또는 타인의 어려움으로 인해 서비스 제공이 방해받는 경우 당사는
          서비스를 제공하지 못할 수 있습니다. 특히 정전, 데이터 네트워크 중단, 제3자에 의한 기타 장애
          또는 천재지변이 발생하는 경우 서비스를 제공하지 못할 수 있습니다.
        </p>
        <p>
          <span className="head_sentence">5.2. 서비스 중단.</span> 서비스 중단, 일시적 제한, 간섭 또는 서비스 품질 저하가 발생할 수 있습니다.
          사용자가 서비스를 통해 저장한 정보는 당사에 의해 백업되지 않을 수 있으며, 손상되거나 질이
          저하될 수 있습니다.
        </p>
        <p>
          <span className="head_sentence">
            5.3. 서비스 품질의 제한.
          </span>{" "}
          법률이 허용하는 범위 내에서 당사는 (i) 웹사이트와 관련된 컴퓨터
          프로그램의 오작동, (ii) 데이터 손실을 초래하는 결함 또는 바이러스, (iii) 사용자의 컴퓨터 장비,
          휴대폰, 모바일 기기 또는 소프트웨어에 대한 기타 손상, (iv) 오류(입력, 표시된 데이터 또는 결과의
          오류 포함), (v) 당사가 의도하지 않은 방식이나 수단으로 웹사이트를 이용하려는 사용자의 시도에
          대해 책임을 지지 않습니다. 당사는 독자적인 판단에 따라 법률이 허용하는 범위 내에서 웹사이트를
          중단, 수정, 제거 또는 보완하고 사용자의 웹사이트 이용을 정지할 권리를 보유합니다. 당사는
          그러한 조치에 대해 책임을 지지 않습니다.
        </p>
        <p>
          <span className="head_sentence">5.4. 오류.</span> 사용자는 웹사이트 상의 사용자 계정 내 오류나 웹사이트에 표시된 정보의 오류(계산
          착오, 오표기, 잘못된 수수료, 수수료, 보너스 또는 지급금, 환전 오류 등을 포함하되 이에 국한되지
          않음)를 당사에 통지하는 데 동의합니다.
        </p>
        <p>
          <span className="head_sentence">5.5. 책임의 제한.</span>{" "}
          당사(당사의 임원, 이사, 대리인 및 직원을 포함) 또는 당사와 관련된 어떠한 사람도
          계약, 불법 행위(과실 포함) 또는 기타 방식으로 인하여 발생하는 직접적, 간접적, 부수적, 결과적,
          특별, 징벌적, 보전적 또는 전형적 손해에 대해 책임을 지지 않습니다. 이는 특히 데이터, 이익, 수익,
          사업, 기회의 손실, 영업권, 평판 또는 사업 중단, 또는 당사가 예측할 수 없었으며 서비스 계약이나
          웹사이트 이용으로 인해 발생하는 기타 손실에 대해 적용됩니다.
        </p>
        <p>
          <span className="head_sentence">5.6. 보상.</span> 웹사이트의 정보는 "있는 그대로" 제공되며, 사용자는 웹사이트 및 웹사이트에 포함된
          정보와 관련하여 당사의 모든 책임을 면제하는 데 동의합니다. 본 약관 제5조의 규정에도 불구하고,
          당사의 책임은 관련 법령이 허용하는 최대 범위 내로 제한됩니다.
        </p>

        <h3 id="article6">6. 서비스의 금지된 이용</h3>
        <p>
          <span className="head_sentence">6.1. 원치 않는 홍보.</span>{" "}
          개인정보 보호, 정보 및 사이버 보안 요건을 준수하고 사기를 방지하기 위해,
          웹사이트에 정보를 게시하거나 당사 고객에게 연락하여 제안, 제품 또는 서비스를 제안하거나
          홍보하는 행위는 명시적으로 금지됩니다.
        </p>
        <p>
          <span className="head_sentence">
            6.2. 사기 방지 및 괴롭힘 방지 정책.
          </span>{" "}
          당사는 웹사이트 내에서의 부적절하고 사기적인 활동에 대해
          무관용 원칙을 적용합니다. 당사의 독자적인 판단에 따라 사용자가 당사 및/또는 웹사이트의 다른
          사용자를 사취하려고 시도했다고 판단되는 경우, 당사는 사용자의 계정을 정지 또는 해지하거나
          특정 또는 무기한 동안 웹사이트 접속을 금지할 권리를 보유합니다. 당사는 관련 법률이 허용하는
          범위 내에서 그러한 조치를 취한 것에 대해 책임을 지지 않습니다.
        </p>

        <h3 id="article7">7. 데이터 보호</h3>
        <p>
          <span className="head_sentence">
            7.1. 개인정보 처리에 관한 정보.
          </span>{" "}
          당사는 개인정보 처리에 관한 정보("개인정보 처리방침")로 지정된
          별도의 문서를 통해, 개인정보 처리와 관련된 자연인의 보호 및 해당 데이터의 자유로운 이동에 관한
          유럽 의회 및 이사회의 규정(EC) 2016/679("GDPR") 제13조에 따른 정보 제공 의무를 이행합니다.
        </p>
        <p>
          <span className="head_sentence">7.2.</span> 본 이용 약관은 웹사이트에서 확인할 수 있는 당사의 개인정보 처리방침과 함께 읽고
          해석되어야 합니다.
        </p>

        <h3 id="article8">8. 서비스 계약의 기간</h3>
        <p>
          <span className="head_sentence">
            8.1. 계약의 효력.
          </span>{" "}
          서비스 계약은 체결과 동시에 효력이 발생합니다. 서비스 계약은 기간의 정함이
          없이 체결됩니다.
        </p>
        <p>
          <span className="head_sentence">
            8.2. 계약 철회.
          </span>{" "}
          계약 체결 시점부터 당사는 즉시 서비스 계약의 이행을 시작하며, 이에 따라
          사용자의 서비스 계약 철회권은 소멸되며 사용자는 본 이용 약관에 따라 이에 동의합니다.
        </p>
        <p>
          <span className="head_sentence">8.3. 계약의 해지.</span>{" "}
          사용자는 언제든지 사용자 계정을 실질적으로 취소함으로써 서비스 계약을 해지할
          수 있습니다. 또한 사용자는 GDPR에 따라 개인정보 삭제를 요청함으로써 서비스 계약을 해지할 수
          있습니다.
        </p>
        <p>
          <span className="head_sentence">
            8.4. 당사에 의한 계약 해지.
          </span>{" "}
          사용자가 서비스 계약(본 이용 약관 포함) 또는 관련 법령에 따른 의무를
          위반하는 경우, 당사는 서비스 계약을 해지할 권리를 보유합니다. 본 조항에 따른 서비스 계약의
          해지는 사용자 주소로 전자 우편이 전달된 때 효력이 발생합니다. 별도의 합의가 없는 한, 서비스
          계약은 해당 해지 효력 발생일에 종료됩니다.
        </p>
      </div>
    </div>
  );
};

export default TermsUse;
